import { render, staticRenderFns } from "./Drawers.vue?vue&type=template&id=2fe0578a&scoped=true&"
import script from "./Drawers.vue?vue&type=script&lang=js&"
export * from "./Drawers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe0578a",
  null
  
)

export default component.exports